import {
  BrowserClient,
  breadcrumbsIntegration,
  dedupeIntegration,
  defaultStackParser,
  getCurrentScope,
  globalHandlersIntegration,
  makeFetchTransport,
  linkedErrorsIntegration,
  replayIntegration,
  functionToStringIntegration,
  httpContextIntegration,
  eventFiltersIntegration,
  thirdPartyErrorFilterIntegration,
} from '@sentry/browser'

const ci = process.env.CI === 'true' || false
const environment = process.env.SENTRY_ENVIRONMENT || 'development'

const client = new BrowserClient({
  dsn: process.env.SENTRY_DSN,
  release: process.env.SENTRY_RELEASE || '',
  environment,
  enabled: ['production', 'staging'].includes(environment) && !ci,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  transport: makeFetchTransport,
  stackParser: defaultStackParser,
  integrations: [
    breadcrumbsIntegration(),
    dedupeIntegration(),
    functionToStringIntegration(),
    globalHandlersIntegration(),
    httpContextIntegration(),
    eventFiltersIntegration(),
    linkedErrorsIntegration(),
    replayIntegration(),
    thirdPartyErrorFilterIntegration({
      filterKeys: ['coffeecircle.com', '_next/static', 'storefront'],
      behaviour: 'drop-error-if-contains-third-party-frames',
    }),
  ],
})

getCurrentScope().setClient(client)

client.init()
